var nutivaProduct = JSON.parse(
   document.getElementById('ProductJson').innerHTML
);

var nutivaProductVariants = nutivaProduct.variants;

var selectors = {
    productFormSelect: 'select.product-form__select',
    // Images
    productImageWraps: '.product-single__image--slide',
    productImageSlider: '.product-single__images',
    // Quantity
    quantityItem: '.product-form__item--quantity input',
    // Pricing
    priceItem: '.product-single__price',
    comparePrice: '.product-single__price--compare',
    originalPrice: '.product-price__price',
    saleClasses: 'product-price--sale',
    // SKU
    SKU: '.variant-sku',
    // Metafields
    metafieldParentSelector: '.product-metafield--parent',
    metafieldChildSelector: '.product-metafield--child',
    metafieldSelectorSansId: '.product-metafield-',
    // Cart
    addToCartButton: '.add-to-cart__button',
    addToCartText: '.add-to-cart__text',
    // Subscribe & Save
    // isSS: false,
    // ssValue: 0.05,
    // ssMode: "percentage"
}

$(window).on('load', function(){
    var variant = getActiveVariant( $( selectors.productFormSelect ).val() );
    if ( variant ) {
        updateProductSelects( variant );
        $('body').trigger( 'ktmOptionTrigger', variant );
    }
});

$( selectors.productFormSelect ).on('change', function( evt ){
    var variant = getActiveVariant( this.value );
    if ( variant ) {
        updateProductSelects( variant );
        $('body').trigger( 'ktmOptionTrigger', variant );
    }
});

$( selectors.quantityItem ).on('change', function(){
    var changedVal = $(this).val();
    $( selectors.quantityItem ).val( changedVal );
});

$('body').on('ktmOptionTrigger',function( event, variant ){
    updateHistoryState( variant );
    updateImages( variant );
    updatePrice( variant );
    updateAddtoCart( variant );
    updateMetadata( variant );
    updateSKU( variant );
    //updateMasterSelect(variant); // Need to do this if multiple variant selections
});

function getActiveVariant( variant_id ) {
    return nutivaProductVariants.find( function( variant ){
        return variant_id == variant.id;
    });
}

function updateProductSelects( variant ) {
    $( selectors.productFormSelect ).each(function( ){
        if ( $(this).val() != variant.id ) {
            $(this).val( variant.id ).trigger("chosen:updated");;
        }
    });
}

function updateHistoryState( variant ) {

    if ( ! variant ) {
        return;
    }

    var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
    window.history.replaceState({ path: newurl }, '', newurl);
  
  
      if (variant) {
      $(".variant-title").text(variant.id);
      }      

      if (variant) {
        var id = variant.id 
        VariantInfo(id);
      }        
}

function updateImages( variant ){

    if ( ! variant ) {
        return;
    }

    if ( ! variant.featured_image ) {
        return;
    }

    var image_id = variant.featured_image.id;
    var selectedImage = selectors.productImageWraps + "[data-image-id='" + image_id + "']";
    var $selectedImage = $( selectedImage );

    if ( ! $selectedImage ) {
        return;
    }

    var slickIndex = $selectedImage.data('slick-index');

    if ( $selectedImage.length ) {
        $( selectors.productImageSlider ).slick('slickGoTo',  slickIndex );
    }

}

function updatePrice( variant ) {

    // Update the product price
    
    $( selectors.originalPrice ).html(
        formatMoney( variant.price, theme.moneyFormat )
    );
    

    // Update and show the product's compare price if necessary
    // Product is on sale
    if ( variant.compare_at_price > variant.price ) {
        $( selectors.comparePrice )
        .html(
            formatMoney(
                variant.compare_at_price,
                theme.moneyFormat
            )
        )
        .removeClass('hide');

        $( selectors.priceItem ).addClass(
            selectors.saleClasses
        );
    // Product is regular price
    } else {
        $( selectors.comparePrice ).addClass('hide');
        $( selectors.priceItem ).removeClass(
            selectors.saleClasses
        );
    }
}

/*
function updateSSPrice( price ) {

    if ( selectors.isSS ) {
        if ( selectors.ssMode == "percentage" ) {
            price = Math.ceil( ( price * ( 1 - selectors.ssValue ) ) * 100 ) / 100;
        } else if ( selectors.ssMode == "fixed_amount" ) {
            price = ( price - ( selectors.ssValue * 100 ) );
        }
    }

    return price;

}
*/

function updateAddtoCart( variant ) {

    if ( variant.available ) {
        $( selectors.addToCartText ).html('Add to Cart');
        $( selectors.addToCartButton ).attr('disabled', false );
    } else {
        $( selectors.addToCartText ).html('Sold Out');
        $( selectors.addToCartButton ).attr('disabled', true );
    }

}

function updateMetadata( variant ) {

    if ( ! variant ) {
        return;
    }

    $('.metafield-variants').each(function(){

        var variantMetafieldActive = $( this ).find( selectors.metafieldSelectorSansId + variant.id );
        var variantMetafieldParent = $( this ).find( selectors.metafieldParentSelector );
        var variantMetafieldChildren = $( this ).find( selectors.metafieldChildSelector );

        if ( variantMetafieldActive.length ) {
            variantMetafieldChildren.hide();
            variantMetafieldParent.hide();
            variantMetafieldActive.show();
        } else {
            variantMetafieldChildren.hide();
            variantMetafieldParent.show();
        }

    });

}

function updateSKU( variant ) {
    $( selectors.SKU ).html( variant.sku );
}

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

function formatMoney( cents, format ) {
    if ( typeof cents === 'string' ) {
        cents = cents.replace( '.', '' );
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters( number, precision, thousands, decimal ) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if ( isNaN( number ) || number === null ) {
            return 0;
        }

        number = ( number / 100.0 ).toFixed( precision );

        var parts = number.split( '.' );
        var dollarsAmount = parts[ 0 ].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[ 1 ] ? decimal + parts[ 1 ] : '';

        return dollarsAmount + centsAmount;
    }

    switch ( formatString.match( placeholderRegex )[ 1 ] ) {
        case 'amount':
            value = formatWithDelimiters( cents, 2 );
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters( cents, 0 );
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters( cents, 2, '.', ',' );
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters( cents, 0, '.', ',' );
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters( cents, 0, ' ' );
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters( cents, 2, "'" );
            break;
    }

    return formatString.replace( placeholderRegex, value );
}


/***** Slick Image Slider *****/

$('.product-single__images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-single__thumbnails',
    responsive: [
            {
                breakpoint: 480,
                settings: {
                    dots: true
                }
            }

      ]  
});

$('.product-single__thumbnails').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-single__images',
    dots: false,
    focusOnSelect: true,
    responsive: [{
        breakpoint: 800,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        }
    },{
        breakpoint: 800,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
        }
    }]
});

/***** Sticky Footer *****/

var st;
var stickyFooter = '.ktm-product__footer';
var stickyFooterActiveClass = 'footer--up';
var trigger = '.product__hero';
var triggerStart;
var triggerEnd;
var timeout = null;

$(window).on('load resize', function(){
    triggerStart = $( trigger ).outerHeight();
    triggerEnd = $("#shopify-section-footer").offset().top - $("#shopify-section-footer").outerHeight();
});

$(window).scroll(function () {
    if (!timeout) {
        timeout = setTimeout(function () {
            clearTimeout(timeout);
            timeout = null;
            st = $( window ).scrollTop();
            var isactive = st > triggerStart && st < triggerEnd;

                $( stickyFooter ).toggleClass( stickyFooterActiveClass, isactive );

        }, 250);
    }
});

var clickIndex = 0;

$('.toggle-mobile-footer').on('click', function(){
    if ( clickIndex >= 1 ){
        $( selectors.addToCartButton ).trigger('click');
    } else {
        clickIndex++;
        $('.ktm-product__footer').removeClass('bg-red');
        $('.ktm-product__footer').addClass('mobile-footer--open');
    }
});

$('.mobile-footer__close').on('click', function(){
    clickIndex = 0;
    $('.ktm-product__footer').addClass('bg-red');
    $('.ktm-product__footer').removeClass('mobile-footer--open');
});


/*
 * ZOOM
 */

$(document).ready(function(){

    $('.img--nutrition-facts').each(function(){
        enableZoom( $(this), {
            'magnify': .25,
        });
    });

    $('.zoom .product-single__image').each(function(){
        enableZoom( $(this) );
    });

});

var ktmZoomUrl,
    ktmZoomArgsDefault,
    ktmZoomArgsAll;

function enableZoom( el, args ){

    args = args || {};

    ktmZoomUrl = $(el).data('zoom');

    if ( !ktmZoomUrl ) {
        ktmZoomUrl = $(el).attr('src');
    }

    ktmZoomArgsDefault = {
        url: ktmZoomUrl,
        alt: $(el).attr('alt'),
        touch: false,
    };

    ktmZoomArgsAll = Object.assign( args, ktmZoomArgsDefault );

    $(el)
        .wrap('<span class="zoom__wrapper"></span>')
        .css('display', 'block')
        .parent()
        .zoom( ktmZoomArgsAll );

}

$('.icon--certification').on('error', function(){
    var text = $(this).attr('alt');
    $('<div class="icon icon--certification certification--placeholder align-content-center"><span>' + text + '</span></div>').insertAfter( this );
    $(this).remove();
});

$(window).on('load', function(){
    if ( $('.SRI-widget [type="radio"]').length ) {
        $('.SRI-widget [type="radio"]').each(function( index, el ){
            $('<span class="radio-button"></span>').insertAfter( el );
        });
    }
    /*
    $('#sri-period-type').chosen({
        disable_search_threshold: 10,
    });
    */
})


/*
 * Power Reviews / No Reviews
 */

$(window).on('load', function(){
    if ( $('.pr-rd-no-reviews').length ) {
        $('.pr-rd-no-reviews').hide();
        $('#pr-no-reviews').show();
    } else {
        $('#pr-no-reviews').remove();
    }
});

/*
 * Subscribe and Save Price Update

$(window).on('load', getSSValue );

var ssOffers;
var ssOffer;
var ssDiscount;

function getSSValue(){
    if ( Spurit ) {
        ssOffers = Spurit.recurringInvoices.config.offers;
        ssOffer = ssOffers.find(function( el ) {
            return el.products.includes( nutivaProduct.id.toString() );
        });
        if ( ssOffer ) {
            if ( ssOffer.discount_type == "percentage" ) {
                ssDiscount = ssOffer.discount_value * .01;
            } else if ( ssOffer.discount_type == "fixed_amount" ) {
                ssDiscount = ssOffer.discount_value;
            }
            selectors.ssMode = ssOffer.discount_type;
            selectors.ssValue = ssDiscount;
        }
    }
}

$(document).on('change', 'input[name="sri-option"]', function(){

    var selectedValue = parseInt( $( this )[0].value ) + 1;

    // Set Variable
    selectors.isSS = ( selectedValue === 2 );

    // Set Active Classes
    $('.ss-option').removeClass('active');
    $('.ss-option--' + selectedValue ).addClass('active');

    // Update Price
    var variant = getActiveVariant( $( selectors.productFormSelect )[0].value );
    if ( variant ) {
        updatePrice( variant );
    }

});

$('.ss-option').on('click', function(){

    $('.ss-option').removeClass('active');
    $(this).addClass('active');

    if ( $(this).hasClass('ss-option--1') ) {
        var target = $('input[name="sri-option"][value="0"]');
    }
    if ( $(this).hasClass('ss-option--2') ) {
        var target = $('input[name="sri-option"][value="1"]');
        scrollToSSForm();
    }

    target.prop('checked', true);
    target.trigger( 'change' );
    target.closest('label').trigger('click');

});

function scrollToSSForm() {
    $( 'html, body' ).animate( {
        scrollTop: $('.SRI-widget').offset().top - 100
    }, 1000, function(){
        $('.SRI-widget-form').addClass( 'shake' ).focus();

        setTimeout( function() {
            $('.SRI-widget-form').removeClass( 'shake' )
        }, 600 );

    });
}
 */